import React, { useEffect, useState, useCallback } from "react";
import { Table, Pagination } from "antd";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsRemaining, // используем тот же набор колонок, как для RemainingStatus
} from "../utils/table";
import OrderStatusFullInfo from "./OrderStatusFullInfo";

const ActiveStatus = ({ query = "", userPermission }) => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // Состояния для пагинации
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  const loadData = useCallback(async (page = 1, pageSize = 20) => {
    try {
      setIsLoading(true);
      // Для "Активных" заявок также используем state ACTIVE и фильтруем оставшиеся заказы
      const res = await fetchStatuses(
        "ACTIVE",
        "",
        query,
        (apps) => {
          setOrders(
            apps.filter(
              (app) =>
                app.status !== "ORDER_INSTALLED" &&
                !(app.status === "ORDER_DELIVERED" && app.isHasMontage === true)
            )
          );
        },
        setIsLoading,
        setTotalCount,
        pageSize,
        page,
        false
      );
      setCurrentPage(res.data.currentPage || page);
      setLimit(pageSize);
      setTotalCount(res.data.totalCount || 0);
    } catch (err) {
      console.error("Error fetching ActiveStatus:", err);
    } finally {
      setIsLoading(false);
    }
  }, [query]);

  // При изменении query сбрасываем страницу на 1
  useEffect(() => {
    loadData(1, limit);
  }, [query, loadData, limit]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setLimit(pageSize);
    loadData(page, pageSize);
  };

  return (
    <div>
      <Table
        size="small"
        bordered
        loading={isLoading}
        dataSource={getOrderStatusDataSource(orders)}
        columns={orderStatusColumnsRemaining}
        pagination={false} // отключаем встроенную пагинацию
        expandable={{
          expandedRowRender: (record) => (
            <OrderStatusFullInfo
              data={record.data}
              userPermission={userPermission}
            />
          ),
        }}
      />
      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          onChange={handlePageChange}
          showSizeChanger
          onShowSizeChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default ActiveStatus;
